import {getCookie} from "@weseus/cms-core/assets/js/helpers";
import netteForms from 'nette-forms';

export default class GtmEventsExtension {

	isGA4Active = false

	constructor(naja) {
		window.dataLayer = window.dataLayer || [];

		let configElement = document.getElementById('fn_ga4_active');
		if (configElement !== null) {
			this.isGA4Active = true;
		}

		naja.addEventListener('success', this.processEvents.bind(this));
		document.addEventListener('click', this.processClickEvents.bind(this));
	}

	enhanceData(data) {
		return data;
	}

	track(data, callback) {
		let pushData = data;

		if (typeof callback === 'function') {
			pushData['eventCallback'] = callback;
		}

		let enhancedData = this.enhanceData(pushData);
		if (this.isGA4Active && enhancedData['ecommerce'] !== undefined) {
			if (getCookie('debug') === '1') {
				console.log('gtm.push:', {ecommerce: null});
			}
			window.dataLayer.push({ecommerce: null});
		}

		if (getCookie('debug') === '1') {
			console.log('gtm.push:', data, callback);
		}

		window.dataLayer.push(this.enhanceData(pushData));

		if (!window.ga || !window.ga.loaded) {
			if (typeof callback === 'function') {
				callback();
			}
		}
	}

	processEvents(e) {
		const payload = e.response;

		if (payload.gtmDataLayer === undefined) {
			return;
		}

		const events = payload.gtmDataLayer;
		for (const event in events) {
			if (events.hasOwnProperty(event)) {
				this.track(events[event])
			}
		}
	}

	processClickEvents(e) {
		let findByAttr = (el, attr) => {

			if (el.hasAttribute(attr)) {
				return el;
			}

			if (el.parentElement) {
				return findByAttr(el.parentElement, attr);
			}

			return undefined;
		};

		const target = findByAttr(e.target, 'data-gtm');

		if (target === undefined) {
			return;
		}

		let data = null;
		try {
			data = JSON.parse(target.dataset.gtm);
		} catch (e) {
			return; // empty data-gtm
		}

		if (target.hasAttribute('href')) {
			e.preventDefault();
			const href = target.href;
			this.track(data, function () {
				if (target.getAttribute('target') === '_blank') {
					window.open(href, '_blank');
				} else {
					document.location = href;
				}
			});
		} else if (target.form !== undefined) {
			if (netteForms.validateForm(target.form)) {
				this.track(data);
			}
		} else {
			e.preventDefault();
			this.track(data);
		}
	}

}